const GENERIC_DOMAINS = new Set([
  'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.fr', 'hotmail.com', 'hotmail.fr',
  'outlook.com', 'outlook.fr', 'live.com', 'live.fr', 'msn.com', 'aol.com', 'icloud.com',
  'me.com', 'mac.com', 'mail.com', 'protonmail.com', 'proton.me', 'zoho.com',
  'gmx.com', 'gmx.fr', 'free.fr', 'orange.fr', 'sfr.fr', 'laposte.net',
  'wanadoo.fr', 'bbox.fr', 'numericable.fr', 'neuf.fr', 'cegetel.net',
]);

const OWN_DOMAINS = new Set(['renoviapro.fr', 'mail.renoviapro.fr']);

const TWO_PART_TLDS = new Set([
  'co.uk', 'org.uk', 'ac.uk', 'gov.uk',
  'com.au', 'net.au', 'org.au',
  'co.nz', 'co.jp', 'co.kr', 'com.br', 'com.mx',
  'com.ar', 'co.za', 'com.sg', 'com.hk', 'com.tw',
]);

/** Domaine racine pour favicon (pro.cedeo.fr → cedeo.fr). */
export function faviconDomain(domain) {
  const host = (domain || '').trim().toLowerCase();
  if (!host) return '';
  const parts = host.split('.').filter(Boolean);
  if (parts.length <= 2) return host;
  const lastTwo = parts.slice(-2).join('.');
  if (TWO_PART_TLDS.has(lastTwo) && parts.length >= 3) {
    return parts.slice(-3).join('.');
  }
  return parts.slice(-2).join('.');
}

export function extractEmailDomain(email) {
  return (email || '').split('@')[1]?.toLowerCase() || '';
}

export function isGenericSenderDomain(domain) {
  return !domain || GENERIC_DOMAINS.has(domain);
}

export function isOwnSenderDomain(domain) {
  return Boolean(domain && OWN_DOMAINS.has(domain));
}

/** Favicon via proxy RenoviaMail (toujours 200, pas de 404 Google dans la console). */
export function senderFaviconUrl(domain) {
  const host = faviconDomain(domain);
  if (!host || isGenericSenderDomain(host) || isOwnSenderDomain(host)) {
    return null;
  }
  return `/api/favicon?domain=${encodeURIComponent(host)}`;
}

export function senderAvatarColor(email) {
  let hash = 0;
  const str = email || '';
  for (let i = 0; i < str.length; i += 1) {
    hash = ((hash << 5) - hash) + str.charCodeAt(i);
    hash |= 0;
  }
  const colors = ['#1a73e8', '#0f9d58', '#e37400', '#c5221f', '#7b1fa2', '#00796b', '#c62828', '#37474f'];
  return colors[Math.abs(hash) % colors.length];
}
